var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "default-page" } }, [
    _c("div", { staticClass: "container full-width" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "search-result-top" }, [
          _c("div", { staticClass: "top" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "a",
                {
                  staticClass: "link",
                  attrs: { href: _vm.$laravelRoute("users.create") }
                },
                [_vm._v("Add New User")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link",
                  attrs: { href: _vm.$laravelRoute("companies.create") }
                },
                [_vm._v("Add New Company")]
              ),
              _vm._v(" "),
              _vm.total > 0
                ? _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: { href: _vm.csvLink, target: "_blank" }
                    },
                    [
                      _vm._v(
                        "\n                            Export CSV\n                        "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bottom" }, [
            _c("span", { staticClass: "showing" }, [
              _c("strong", [_vm._v("Showing")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.from))]),
              _vm._v("-"),
              _c("span", [_vm._v(_vm._s(_vm.to))]),
              _vm._v(" of "),
              _c("span", [_vm._v(_vm._s(_vm.total))]),
              _vm._v("\n                    results\n                ")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search"
                }
              ],
              attrs: { placeholder: "search" },
              domProps: { value: _vm.search },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value
                  },
                  _vm.filterBy
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.status_id,
                    expression: "status_id"
                  }
                ],
                attrs: { id: "status", name: "status" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.status_id = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.filterBy
                  ]
                }
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v("Filter status")
                ]),
                _vm._v(" "),
                _vm._l(_vm.statuses, function(status) {
                  return _c("option", { domProps: { value: status.id } }, [
                    _vm._v(_vm._s(status.name))
                  ])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.role_id,
                    expression: "role_id"
                  }
                ],
                attrs: { id: "role", name: "role" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.role_id = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.filterBy
                  ]
                }
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v("Filter roles")
                ]),
                _vm._v(" "),
                _vm._l(_vm.user_roles, function(role) {
                  return _c("option", { domProps: { value: role.id } }, [
                    _vm._v(_vm._s(role.name))
                  ])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sales_rep_id,
                    expression: "sales_rep_id"
                  }
                ],
                attrs: { id: "sales-reps", name: "sales_rep" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.sales_rep_id = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.filterBy
                  ]
                }
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v("Filter customers by rep")
                ]),
                _vm._v(" "),
                _vm._l(_vm.salesReps, function(salesRep) {
                  return _c("option", { domProps: { value: salesRep.id } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          salesRep.first_name +
                            " " +
                            salesRep.last_name +
                            " (" +
                            salesRep.username +
                            ")"
                        ) +
                        "\n                        "
                    )
                  ])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.per_page,
                    expression: "per_page"
                  }
                ],
                attrs: { id: "per_page", name: "sales_rep" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.per_page = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.filterBy
                  ]
                }
              },
              [
                _c("option", { domProps: { value: 100 } }, [
                  _vm._v("100 per page")
                ]),
                _vm._v(" "),
                _c("option", { domProps: { value: 500 } }, [
                  _vm._v("500 per page")
                ]),
                _vm._v(" "),
                _c("option", { domProps: { value: 2000 } }, [
                  _vm._v("Show max")
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-table" },
          [
            _c("b-table", {
              staticClass: "list-table",
              attrs: {
                responsive: "",
                "sort-by": _vm.sort_by,
                "sort-asc": _vm.sort_asc,
                fields: _vm.fields,
                items: _vm.users,
                "show-empty": ""
              },
              on: {
                "update:sortBy": function($event) {
                  _vm.sort_by = $event
                },
                "update:sort-by": function($event) {
                  _vm.sort_by = $event
                },
                "update:sortAsc": function($event) {
                  _vm.sort_asc = $event
                },
                "update:sort-asc": function($event) {
                  _vm.sort_asc = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "empty",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.empty_message) +
                          "\n                    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(first_name)",
                  fn: function(data) {
                    return [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: _vm.$laravelRoute(
                              "users.show",
                              data.item.id,
                              false
                            )
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(data.item.first_name) +
                              " " +
                              _vm._s(data.item.last_name) +
                              " (" +
                              _vm._s(data.item.username) +
                              ")\n                        "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "cell(company_id)",
                  fn: function(data) {
                    return [
                      data.item.company && data.item.company.name
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.$laravelRoute(
                                  "companies.show",
                                  data.item.company_id
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.company.name) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(region)",
                  fn: function(data) {
                    return [
                      data.item.region && data.item.region.name
                        ? _c("span", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(data.item.region.name) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(bids_count)",
                  fn: function(data) {
                    return [
                      data.item.bids_count
                        ? _c(
                            "router-link",
                            {
                              attrs: {
                                to:
                                  _vm.$laravelRoute(
                                    "user-bid.index",
                                    [],
                                    false
                                  ) +
                                  "?filter_user_ids=" +
                                  data.item.id
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.bids_count) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s(data.item.bids_count))])
                    ]
                  }
                },
                {
                  key: "cell(stock_count)",
                  fn: function(data) {
                    return [
                      data.item.stock_count
                        ? _c(
                            "router-link",
                            {
                              attrs: {
                                to: _vm.$laravelRoute(
                                  "users.stockList",
                                  data.item.id,
                                  false
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.stock_count) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s(data.item.stock_count))])
                    ]
                  }
                },
                {
                  key: "cell(recommends_count)",
                  fn: function(data) {
                    return [
                      data.item.recommends_count
                        ? _c(
                            "router-link",
                            {
                              attrs: {
                                to:
                                  _vm.$laravelRoute(
                                    "recommended.index",
                                    [],
                                    false
                                  ) +
                                  "?user_id=" +
                                  data.item.id
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.recommends_count) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _c("span", [
                            _vm._v(_vm._s(data.item.recommends_count))
                          ])
                    ]
                  }
                },
                {
                  key: "cell(colour)",
                  fn: function(data) {
                    return [
                      data.item.profile
                        ? _c(
                            "div",
                            {
                              staticClass: "bid-colour",
                              style:
                                "background-color: " +
                                data.item.profile.bid_color
                            },
                            [
                              _vm._v(
                                "\n                             \n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(fees)",
                  fn: function(data) {
                    return [
                      data.item.pricing_rule_id && _vm.defaultPricing
                        ? [
                            _vm.defaultPricing.id === data.item.pricing_rule_id
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                Default\n                            "
                                  )
                                ])
                              : _c("div", { staticClass: "text-warning" }, [
                                  _vm._v(
                                    "\n                                Custom\n                            "
                                  )
                                ])
                          ]
                        : _c("div", [
                            _vm._v(
                              "\n                            Default\n                        "
                            )
                          ])
                    ]
                  }
                },
                {
                  key: "cell(assigned_rep)",
                  fn: function(data) {
                    return [
                      data.item.sales_rep
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.$laravelRoute(
                                  "users.show",
                                  data.item.sales_rep.id
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.sales_rep.first_name) +
                                  " " +
                                  _vm._s(data.item.sales_rep.last_name) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(bump_bid)",
                  fn: function(data) {
                    return [
                      data.item.bump_bid &&
                      data.item.bump_bid.ranges &&
                      data.item.bump_bid.ranges.length
                        ? _c("div", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  data.item.bump_bid.ranges[0].fee / 1000
                                ) +
                                "k between\n                            " +
                                _vm._s(data.item.bump_bid.ranges[0].price_min) +
                                " - " +
                                _vm._s(data.item.bump_bid.ranges[0].price_max) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(settings)",
                  fn: function(data) {
                    return [
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "p-2 flex-grow-1" }, [
                          _vm._v(
                            _vm._s(
                              data.item.privileges.attended_auctions ? "A" : " "
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-2 flex-grow-1" }, [
                          _vm._v(
                            _vm._s(
                              data.item.privileges.show_inspection ? "I" : " "
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-2 flex-grow-1" }, [
                          _vm._v(
                            _vm._s(
                              data.item.privileges.show_auction_site ? "S" : " "
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-2 flex-grow-1" }, [
                          _vm._v(
                            _vm._s(
                              data.item.privileges.show_lot_number ? "L" : " "
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-2 flex-grow-1" }, [
                          _vm._v(
                            _vm._s(
                              data.item.privileges.add_url_logo_image
                                ? "U"
                                : " "
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-2 flex-grow-1" }, [
                          _vm._v(
                            _vm._s(
                              data.item.privileges.enable_email ? "E" : " "
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-2 flex-grow-1" }, [
                          _vm._v(
                            _vm._s(
                              data.item.privileges.display_auction_result
                                ? "R"
                                : " "
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-2 flex-grow-1" }, [
                          _vm._v(
                            _vm._s(
                              data.item.privileges.enable_market_price
                                ? "M"
                                : " "
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-2 flex-grow-1" }, [
                          _vm._v(
                            _vm._s(
                              data.item.privileges.enable_auto_notice
                                ? "N"
                                : " "
                            )
                          )
                        ])
                      ])
                    ]
                  }
                },
                {
                  key: "cell(action)",
                  fn: function(data) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "link",
                              attrs: {
                                to: _vm.$laravelRoute(
                                  "users.edit",
                                  data.item.id,
                                  false
                                )
                              }
                            },
                            [_vm._v("Edit")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "link",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.deleteUser(data.item)
                                }
                              }
                            },
                            [_vm._v("Delete")]
                          ),
                          _vm._v(" "),
                          _vm.userHasPrivilege("can_login_as")
                            ? _c(
                                "a",
                                {
                                  staticClass: "link",
                                  attrs: { href: "#!" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.loginAs(data.item.id)
                                    }
                                  }
                                },
                                [_vm._v("login")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bottom-table" },
          [
            _vm.total > 0
              ? _c("b-pagination", {
                  attrs: { "total-rows": _vm.total, "per-page": _vm.per_page },
                  model: {
                    value: _vm.current_page,
                    callback: function($$v) {
                      _vm.current_page = $$v
                    },
                    expression: "current_page"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h2", [
        _vm._v("\n                            Users\n                        ")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42f79841", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f79841","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/UserListPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-42f79841","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/UserListPage.vue
// module chunks = 0